export const COMPLIANCE_FRAMEWORKS = [
  // --- LESSON 1 (ACTIVE): Channel Surfer ---
  {
    id: "reward_001_channel_surfer",
    linkedGameId: "game_channel_surfer", 
    title: "The Comm-Channel Protocol",
    category: "Communication",
    type: "checklist",
    description: "Stop guessing where to post. Keep this decision tree handy.",
    content: [
      "Is it URGENT? (Fire/Crash) -> Call or Text",
      "Is it SENSITIVE? (Pay/Conflict) -> Private Zoom (Never Slack)",
      "Is it COMPLEX? (Nuance needed) -> Zoom/Meeting",
      "Is it OFFICIAL? (Paper trail needed) -> Email",
      "Is it QUICK? (Yes/No answer) -> Slack/Teams",
      "Is it SOCIAL? (Tacos/Memes) -> Watercooler Channel"
    ]
  },

  {
    id: "reward_001_slack_attack",
    linkedGameId: "game_slack_attack", 
    title: "The 'One-Touch' DM Template",
    category: "Communication", 
    type: "copy_paste", 
    description: "Never send 'hey' again. Use this formula to get faster replies.",
    content: `Hey [Name],

Do you have 5 mins to review [Project Name]?

I'm stuck on [Specific Issue] and need to finalize it by [Time].

Thanks!`
  },
  
  // --- LESSON 2: The Gatekeeper ---
  {
    id: "reward_002",
    linkedGameId: "game_gatekeeper", // ALIGNED ID
    title: "The 'Manager Whisperer' Scripts",
    category: "Conflict Resolution",
    type: "copy_paste",
    description: "Scripts to save you when things go wrong.",
    content: `WHEN YOU MESS UP:
"Thank you for telling me. Can you give me an example so I can make sure I fix it next time?"

WHEN YOU FIND A PROBLEM:
"I found an issue with [X]. I've looked into it, and we can either try Option A or Option B. What do you think?"`
  },
  
  // --- LESSON 3: Resume Roaster ---
  {
    id: "reward_003_resume", 
    linkedGameId: "game_resume_roaster",
    title: "The Resume Red-Flag Checklist",
    category: "Career Strategy",
    type: "checklist",
    description: "Don't let these mistakes sneak into your application.",
    content: [
      "Email: Use a professional format (firstname.lastname@gmail.com).",
      "Photo: No headshots unless you are an actor or model.",
      "Typos: 'Attention to detail' with a typo is an instant rejection.",
      "Fonts: Stick to clean serifs or sans-serifs (No Comic Sans).",
      "Relevance: Remove awards/hobbies from more than 10 years ago."
    ]
  },

  // --- LESSON 4: Meeting Hero (Battle Royale) ---
  {
    id: "reward_004",
    linkedGameId: "game_meeting_hero", 
    title: "The Virtual Meeting Framework",
    category: "Professionalism",
    type: "checklist", 
    description: "Keep this open during your next Zoom call.",
    content: [
      "Tech Check (Audio/Video tested 2 mins prior)",
      "Camera ON (Shows presence)",
      "Mic MUTED (Respects audio)",
      "No Multitasking (They can tell)",
      "Question: 'Could you help me understand the history behind [Topic]?'",
      "Closing: 'So next steps are [A] and [B], right?'"
    ]
  },

  // --- LESSON 7: Culture Vibe ---
  {
    id: "reward_005",
    linkedGameId: "game_culture_vibe", // ALIGNED ID
    title: "The 'Run Away' Radar",
    category: "Career Strategy",
    type: "checklist",
    description: "5 subtle signs a company is toxic (before you accept the offer).",
    content: [
      "The Manager says: 'We are like a family here.' (Translation: No boundaries)",
      "High Turnover: Everyone on the team has been there < 6 months.",
      "Exploding Offer: 'You must decide in 24 hours.'",
      "The 'Hero' Culture: Praising people for working weekends.",
      "Vague Answers: They can't describe a typical day."
    ]
  },

  // --- LESSON 9: Final Exam (The Gauntlet) ---
  {
    id: "reward_006_final",
    linkedGameId: "game_final_exam", 
    title: "The Professionalism 'Go-Bag'",
    category: "Mastery",
    type: "checklist",
    description: "You survived the gauntlet. Take these rules with you.",
    content: [
      "Punctuality: 'On time' is late. 5 minutes early is on time.",
      "Ownership: Don't guess. Ask clarifying questions immediately.",
      "Composure: Never reply to angry emails instantly. Wait, draft, edit.",
      "Integrity: Own your mistakes before someone else finds them.",
      "Reliability: Consistency beats occasional brilliance every time."
    ]
  }
];